import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 15 15"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.2",
      d: "M11 2.2H3.4a1.6 1.6 0 0 0-1.6 1.6V13l3-2.4H11A1.6 1.6 0 0 0 12.6 9V3.8A1.6 1.6 0 0 0 11 2.2M4.6 5h5.2M4.6 7.8H8"
    }, null, -1)
  ]))]))
}
export default { render: render }